import { ShallowPreviewOverlayViewModel } from './preview-overlay.view-model';

export abstract class AbstractPreviewOverlayGtmService {
  public abstract measureButtonClick(vm: ShallowPreviewOverlayViewModel, buttonText: string): void;
  public abstract measureGenreClick(vm: ShallowPreviewOverlayViewModel, genreName: string): void;
  public abstract measureExpandHoverDescription(vm: ShallowPreviewOverlayViewModel): void;
}
